var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-dropzone q-pa-md",
      class: { dragover: _vm.isDragover },
      on: {
        drop: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleDrop($event)
        },
        drageenter: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleDragenter($event)
        },
        dragleave: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleDragleave($event)
        },
        dragover: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleDragenter($event)
        },
        dragend: _vm.handleDragleave
      }
    },
    [
      _c(
        "label",
        { staticClass: "file-upload-btn", attrs: { for: "fileUpload" } },
        [
          _c("input", {
            attrs: {
              id: "fileUpload",
              type: "file",
              accept: _vm.acceptForInput,
              multiple: ""
            },
            on: { change: _vm.handleFileInput }
          }),
          _c("q-icon", { attrs: { name: "cloud_upload", size: "1.75rem" } }),
          _c("span", { staticClass: "q-mt-sm" }, [
            _vm._v(_vm._s(_vm.$t("upload_document_dropzone_text")))
          ])
        ],
        1
      ),
      _vm.hasFiles
        ? _c(
            "div",
            { staticClass: "file-preview" },
            _vm._l(_vm.files, function(file, index) {
              return _c(
                "div",
                {
                  key: file.file.name + "_" + index,
                  staticClass: "file-preview-element"
                },
                [
                  [
                    _vm.fileIsImage(file.file)
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: file.loaded,
                                expression: "file.loaded"
                              }
                            ],
                            staticClass: "image-preview",
                            on: { mouseenter: _vm.handleMouseEnter }
                          },
                          [
                            _c("img", {
                              attrs: { src: file.base64 },
                              on: {
                                load: function() {
                                  return (file.loaded = true)
                                }
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm.fileIsPdf(file.file)
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: file.loaded,
                                expression: "file.loaded"
                              }
                            ],
                            staticClass: "pdf-preview",
                            on: { mouseenter: _vm.handleMouseEnter }
                          },
                          [
                            _c("pdf", {
                              attrs: { src: file.base64 },
                              on: {
                                loaded: function() {
                                  return (file.loaded = true)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  !file.loaded
                    ? [
                        _c(
                          "div",
                          { staticClass: "placeholder-preview" },
                          [_c("q-spinner")],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "file-preview-meta" },
                    [
                      _c("q-btn", {
                        staticClass: "file-preview-delete q-pa-xs",
                        attrs: {
                          icon: "close",
                          size: "sm",
                          color: "red-5",
                          flat: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.handleDeleteFile(index)
                          }
                        }
                      }),
                      _c("span", { staticClass: "file-preview-filename" }, [
                        _vm._v(_vm._s(file.file.name))
                      ]),
                      _c("span", { staticClass: "file-preview-filesize" }, [
                        _vm._v(_vm._s(file.humanReadableSize))
                      ])
                    ],
                    1
                  )
                ],
                2
              )
            })
          )
        : _vm._e(),
      _vm.hasFiles
        ? _c("div", { staticClass: "flex justify-center" }, [
            _c(
              "div",
              [
                _c(
                  "q-btn",
                  {
                    attrs: { color: "primary", size: "sm" },
                    on: { click: _vm.handleUpload }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.$t("upload")) + "\n      ")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.isUploading } },
        [
          _c("span", { staticClass: "q-mb-sm" }, [
            _vm._v(
              _vm._s(_vm.filesToUpload - _vm.files.length) +
                " / " +
                _vm._s(_vm.filesToUpload)
            )
          ]),
          _c("q-spinner", { attrs: { size: "42px", color: "primary" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }